import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { baseUrl, socketUrl } from "../../Common/BaseUrl";
import $ from "jquery";
import "slick-carousel/slick/slick.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import socketIOClient from "socket.io-client";
import config from "../../../utils/config";
const { imageUrl } = config;

function Table() {
  const [banners, setBanners] = useState([]);
  const [topGainerData, setTopGainerData] = useState([]);
  const [topLoserData, setTopLoserData] = useState([]);

  const clientRef = useRef(null);
  const sliderRef = useRef(null);
  const isSlickAvailable = typeof $.fn?.slick === "function";

  useEffect(() => {
    let isMounted = true;

    const getHomeBanners = async () => {
      try {
        const res = await axios.get(`${baseUrl}/banners/get`);
        if (isMounted) {
          setBanners(Array.isArray(res?.data?.data) ? res.data.data : []);
        }
      } catch (error) {
        if (isMounted) {
          setBanners([]);
        }
      }
    };

    getHomeBanners();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const sliderEl = sliderRef.current;
    if (!sliderEl) return;

    const $slider = $(sliderEl);
    if (typeof $slider.slick !== "function") return;

    if (banners.length > 2) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    } else if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }

    return () => {
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    };
  }, [banners.length]);

  // ---------------- SOCKET INIT ----------------
  useEffect(() => {
    if (!clientRef.current) {
      clientRef.current = socketIOClient(socketUrl, {
        transports: ["websocket"],
      });

      clientRef.current.on("connect", (socket) => {
        // handleSocketData(clientRef.current, clientRef.current.id);
      });
      // clientRef.current.emit(
      //   "tab_list", // <-- You must have this event in backend
      //   // {},
      //   // (res) => {
      //   //   console.log(res, "jao");
      //   //   if (res?.status) {
      //   //     set_exchangeTab(res.data);
      //   //   } else {
      //   //     toast.error(res?.message || "Failed to load tabs");
      //   //   }
      //   // }
      // );
      clientRef.current.on("pairs_list", (data) => {
        // Convert % to number
        const formatted = data.map((item) => ({
          ...item,
          change: parseFloat(item.change_persentage),
        }));

        // ----- Top 5 Gainers -----
        const gainers = formatted
          .filter((item) => item.change > 0) // only positives
          .sort((a, b) => b.change - a.change) // highest first
          .slice(0, 5); // top 5

        // ----- Top 5 Losers -----
        const losers = formatted
          .filter((item) => item.change < 0) // only negatives
          .sort((a, b) => a.change - b.change) // lowest first (more negative)
          .slice(0, 5); // top 5

        setTopGainerData(gainers);
        setTopLoserData(losers);
      });

      // clientRef.current.emit("coinPairDataLive");
    }

    return () => {
      if (clientRef.current) {
        console.log("WebSocket connection closed on unmount.");
        clientRef.current.disconnect();
      }
    };
  }, []);

  const getBannerImage = (bannerImage) => {
    if (!bannerImage) return "";
    if (
      bannerImage.startsWith("http://") ||
      bannerImage.startsWith("https://")
    ) {
      return bannerImage;
    }
    return `${imageUrl}/${bannerImage}`;
  };

  const GainerHtml = () => {
    if (topGainerData.length === 0) return null;

    return topGainerData.map((value, i) => {
      return (
        <div className="col-md-4 col-12 more-space" key={i}>
          <div className="winloss-inner d-flex flex-wrap align-items-center">
            <div className="winloss-left">
              <div className="left-top d-flex align-items-center">
                <div className="img-outer">
                  <img
                    src={
                      imageUrl +
                      "/images/" +
                      value?.pair?.split("/")[0].toLowerCase() +
                      ".svg"
                    }
                    alt="CurrencyImage"
                    className="img-fluid"
                    onError={(e) =>
                      (e.target.src =
                        "https://dummyimage.com/40x40/cccccc/000000.png&text=ven")
                    }
                  />
                </div>
                <div className="content-outer">
                  <span>
                    <b>{value.pair}</b>
                  </span>
                </div>
              </div>
              <div className="left-bottom">
                <p
                  className="text"
                  style={{ color: value?.current_price_flag }}
                >
                  <span className="d-block text-white">Last Price</span>{" "}
                  {value?.current_price}
                </p>
              </div>
            </div>

            <div className="winloss-right">
              <p
                className="text"
                style={{ color: value?.change_persentage_flag }}
              >
                {value?.change_persentage} %
              </p>
              <div className="trade-btn">
                <a href={`/exchange/${value.pair}`} className="btn btn_man">
                  Trade Now
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const LoserHtml = () => {
    if (topLoserData.length === 0) return null;

    return topLoserData.map((value, i) => {
      return (
        <div className="col-md-4 col-12 more-space" key={i}>
          <div className="winloss-inner d-flex flex-wrap align-items-center">
            <div className="winloss-left">
              <div className="left-top d-flex align-items-center">
                <div className="img-outer">
                  <img
                    src={
                      imageUrl +
                      "/images/" +
                      value?.pair?.split("/")[0].toLowerCase() +
                      ".svg"
                    }
                    alt="CurrencyImage"
                    className="img-fluid"
                    onError={(e) =>
                      (e.target.src =
                        "https://dummyimage.com/40x40/cccccc/000000.png&text=ven")
                    }
                  />
                </div>
                <div className="content-outer">
                  <span>
                    <b>{value?.pair}</b>
                  </span>
                </div>
              </div>
              <div className="left-bottom">
                <p
                  className="text"
                  style={{ color: value?.current_price_flag }}
                >
                  <span className="d-block text-white">Last Price</span>{" "}
                  {value?.current_price}
                </p>
              </div>
            </div>

            <div className="winloss-right">
              <p
                className="text"
                style={{ color: value?.change_persentage_flag }}
              >
                {value?.change_persentage} %
              </p>
              <div className="trade-btn">
                <a href={`/exchange/${value?.pair}`} className="btn btn_man">
                  Trade Now
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="intro-main-outer" id="token" data-scroll-index="3">
      <div className="container">
        {banners.length > 0 ? (
          <div className="card-slider">
            {banners.length > 2 && isSlickAvailable ? (
              <div ref={sliderRef} className="slider multiple-items">
                {banners.map((banner) => (
                  <div key={banner.id} className="px-2">
                    <div className="card-outer">
                      <img
                        src={getBannerImage(banner.image)}
                        alt={banner.title || "home-banner"}
                        className="img-fluid"
                        onError={(e) =>
                          (e.target.src =
                            "https://dummyimage.com/700x300/cccccc/000000.png&text=Banner")
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div ref={sliderRef} className="row">
                {banners.map((banner) => (
                  <div
                    key={banner.id}
                    className={`${
                      banners.length === 1 ? "col-md-12" : "col-md-6"
                    } col-12 mb-4`}
                  >
                    <div className="card-outer">
                      <img
                        src={getBannerImage(banner.image)}
                        alt={banner.title || "home-banner"}
                        className="img-fluid"
                        onError={(e) =>
                          (e.target.src =
                            "https://dummyimage.com/700x300/cccccc/000000.png&text=Banner")
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : null}

        <div className="intro-outer">
          <div className="row">
            <div className="col-md-3 col-12">
              <div className="intro-left">
                <img
                  src="assets/img/logo-icon.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>

            <div className="col-md-9 col-12">
              <div className="intro-right">
                <h2>Introducing Green Crypto Exchange</h2>
                <p>
                  Green Crypto Exchange is India's one of the most crypto exchange
                  platforms...
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Table Removed in your original code */}

        <div className="winloss-outer">
          <div className="section-heading">
            <h5 className="mb-0">Top Gainer</h5>
            <p className="m-0">Coins that have gained the must in 24 hours</p>
          </div>
          <div className="row">{GainerHtml()}</div>
        </div>

        <div className="winloss-outer">
          <div className="section-heading">
            <h5 className="mb-0">Top Losers</h5>
            <p className="m-0">
              Coins that have corrected the must in 24 hours
            </p>
          </div>
          <div className="row">{LoserHtml()}</div>
        </div>
      </div>
    </div>
  );
}

export default Table;
